// Merge the three transcript sources for display. Streaming STT segments
// are preferred over the agent's committed transcript_item echoes; locally
// echoed typed prompts (chatPrompts) suppress the agent's user-role echo of
// the same text.
//
// Echo suppression matches by exact trimmed text, not by timestamp: the
// worker's clock and the local clock can drift, so a time-window comparison
// either misses echoes or (worse) drops a genuinely spoken duplicate. Instead
// each chat prompt consumes the first not-yet-consumed user-role segment in
// `base` with identical trimmed text, walking `base` in its own arrival
// order -- so "typed then spoke the same word" keeps the second occurrence
// (only the first matching one, presumed to be the echo, is dropped). This
// is a heuristic, not a guarantee: with no correlation ID, a genuinely
// spoken duplicate that arrives before any echo is itself consumed as if it
// were the echo (see the "spoken with no echo" test below) -- a documented
// trade-off, not a bug.
export function mergeTranscript(transcript, streaming, chatPrompts) {
    const base = streaming.length > 0
        ? streaming
        : transcript.map((t, i) => ({
            id: `t-${t.timestamp}-${i}`,
            role: t.role,
            text: t.text,
            timestamp: t.timestamp,
            isFinal: true,
        }));
    // One pending echo slot per chat prompt, consumed at most once as base is
    // walked in order.
    const pendingEchoes = chatPrompts.map((p) => p.text.trim());
    const deduped = base.filter((s) => {
        if (s.role !== "user")
            return true;
        const idx = pendingEchoes.indexOf(s.text.trim());
        if (idx === -1)
            return true;
        pendingEchoes.splice(idx, 1);
        return false;
    });
    return [...deduped, ...chatPrompts].sort((a, b) => a.timestamp - b.timestamp);
}
